import { lazy } from 'react';

import ElcLogo from '../../assets/images/logo/ELC-logo.png';

const ReferralRoutes = [
    {
        path: '/case/:referralId',
        component: lazy(() =>
            import('../../pages/Referrals/ReferralDashbaord'),
        ),
        meta: {
            action: 'read',
            resource: 'referral',
        },
    },
    {
        path: '/new_referral',
        component: lazy(() =>
            import('../../pages/Referrals/CreateLrsReferral'),
        ),
        meta: {
            action: 'create',
            resource: 'lrs_referral',
        },
    },
    {
        path: '/create_referral',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        component: lazy(() => import('../../pages/Referrals/CreateReferral')),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_elc_referral',
        layout: 'auto',
        showNavbar: true,
        navbarType: 'elc',
        navbarLink: 'https://www.everyonelegal.ca/',
        logo: ElcLogo,
        showFooter: true,
        footerType: 'elc',
        showLogin: false,
        showMenus: false,
        showQaseLink: true,
        component: lazy(() =>
            import('../../pages/Referrals/CreateELCReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_lfp_referral',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        // showQaseLink: true,
        component: lazy(() =>
            import('../../pages/Referrals/CreateLFPReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_acba_referral',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        //logo: AcbaLogo,
        showPoweredBy: true,
        footerType: 'acba',
        component: lazy(() =>
            import('../../pages/Referrals/ACBA/CreateAcbaReferralAnonymous'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/schedule_appointment',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        component: lazy(() =>
            import('../../pages/Referrals/ScheduleAppointment'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/active_referrals',
        component: lazy(() => import('../../pages/Referrals/LookUp')),
        meta: {
            action: 'read',
            resource: 'referral',
        },
    },
    {
        path: '/new_referrals',
        component: lazy(() => import('../../pages/Referrals/NewReferrals')),
        meta: {
            action: 'read',
            resource: 'lawyer_referrals',
        },
    },
    {
        path: '/lead_intake',
        component: lazy(() => import('../../pages/Referrals/Leads')),
        meta: {
            action: 'read',
            resource: 'lawyer_referrals',
            //menuCollapsed: true,
        },
    },
    {
        path: '/matters',
        exact: true,
        component: lazy(() => import('../../pages/Matters')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/matters/:matterId',
        component: lazy(() => import('../../pages/Matters/Detail')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/appointments',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Appointments')),
        meta: {
            action: 'read',
            resource: 'matter_appointments',
            //menuCollapsed: true,
        },
    },
    {
        path: '/appointments/:matterId',

        component: lazy(() => import('../../pages/Matters/Appointments')),
        meta: {
            action: 'read',
            resource: 'matter_appointments',
            //menuCollapsed: true,
        },
    },
    {
        path: '/tasks',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Tasks')),
        meta: {
            action: 'read',
            resource: 'matter_tasks',
            //menuCollapsed: true,
        },
    },
    {
        path: '/tasks/:matterId',
        component: lazy(() => import('../../pages/Matters/Tasks')),
        meta: {
            action: 'read',
            resource: 'matter_tasks',
            //menuCollapsed: true,
        },
    },
    {
        path: '/messages',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Messages')),
        meta: {
            action: 'read',
            resource: 'matter_messages',
            //menuCollapsed: true,
        },
    },
    {
        path: '/messages/:matterId',
        component: lazy(() => import('../../pages/Matters/Messages')),
        meta: {
            action: 'read',
            resource: 'matter_messages',
            //menuCollapsed: true,
        },
    },
    {
        path: '/notes',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Notes')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/notes/:matterId',
        component: lazy(() => import('../../pages/Matters/Notes')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/documents',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Documents')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/documents/:matterId',
        component: lazy(() => import('../../pages/Matters/Documents')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/transactions',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Transactions')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/transactions/:matterId',
        component: lazy(() => import('../../pages/Matters/Transactions')),
        meta: {
            action: 'read',
            resource: 'matters',
            //menuCollapsed: true,
        },
    },
    {
        path: '/conference/:appointmentId',
        component: lazy(() => import('../../pages/Matters/Conference')),
        layout: 'auto',
        showNavbar: true,
        showFooter: false,
        showMenus: false,
        showLogin: false,
        navbarTitle: 'Powered by',
        containerType: 'fluid',
        meta: {
            action: 'read',
            resource: 'conference',
            publicRoute: true,
        },
    },
    {
        path: '/phone_conference/:appointmentId',
        component: lazy(() =>
            import('../../pages/Matters/Conference/PhoneConference'),
        ),
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        meta: {
            action: 'read',
            resource: 'conference',
        },
    },
    {
        path: '/create_pending_referral',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        component: lazy(() =>
            import('../../pages/Referrals/CreatePendingReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_scba_referral',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        showFooter: true,
        footerType: 'scba',
        component: lazy(() =>
            import('../../pages/Referrals/SCBA/CreateReferralAnonymous'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_scba_pending_referral',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        showFooter: true,
        footerType: 'scba',
        component: lazy(() =>
            import('../../pages/Referrals/SCBA/CreatePendingReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_ecba_pending_referral',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        showFooter: true,
        footerType: 'ecba',
        component: lazy(() =>
            import('../../pages/Referrals/CreatePendingReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_mnlrs_pending_referral',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        navbarTextLogo: 'Minnesota Lawyer Referral and Information Service',
        navbarTextLogoStyle: {
            color: '#0693e3',
        },
        navbarLink: 'https://www.mnlawyerreferral.org/',
        showFooter: true,
        footerType: 'mnlrs',
        component: lazy(() =>
            import('../../pages/Referrals/CreatePendingReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_mnlrs_referral',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        showFooter: true,
        footerType: 'mnlrs',
        component: lazy(() =>
            import('../../pages/Referrals/SCBA/CreateReferralAnonymous'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create_acba_self_referral',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        component: lazy(() =>
            import('../../pages/Referrals/SCBA/CreateReferralAnonymous'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/referral-request',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        component: lazy(() =>
            import('../../pages/Referrals/CreateUncompletedReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
    {
        path: '/create-self-referral',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        // footerType: 'epbc',
        component: lazy(() =>
            import('../../pages/Referrals/SCBA/CreateReferralAnonymous'),
        ),
        meta: {
            publicRoute: true,
            action: 'create',
            resource: 'referral',
        },
    },
];

export default ReferralRoutes;
